import "./CloudAccounting.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import BenefitsOfCloudAccounting from "./sections/BenefitsOfCloudAccounting";
import PlatformOverview from "./sections/PlatformOverview";
import CloudSolutions from "./sections/CloudSolutions";
import FrequentlyAskedQuestions from "./sections/FrequentlyAskedQuestions";
import Footer from "@/reusable_sections/Footer";
import CloudAccountingHero from "./sections/CloudAccountingHero";
export default function CloudAccountingPage() {
  return <div>
      <Header />
      <Hero />
      <BenefitsOfCloudAccounting />
      <CloudAccountingHero />
      <PlatformOverview />
      <CloudSolutions />
      <FrequentlyAskedQuestions />
      <Footer />
    </div>;
}